import { gql } from "@apollo/client";

import { MEMBERSHIP_MANAGEMENT_FLOW_FRAGMENT } from "../fragments";

// We need to find a way to test these fragments in isolation
export const MEMBERSHIP_MANAGEMENT_FLOW_MUTATION = gql`
  mutation membershipManagementFlow(
    $branchName: String!
    $preview: Boolean!
    $flow: String!
    $data: MembershipManagementSubmitData
  ) {
    membershipManagementFlow(
      branchName: $branchName
      preview: $preview
      flow: $flow
      data: $data
    ) {
      ...membershipManagementFlow
    }
  }
  ${MEMBERSHIP_MANAGEMENT_FLOW_FRAGMENT}
`;
